// extracted by mini-css-extract-plugin
export var container = "_dq-0";